/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { RootComponent } from './app/root/root.component';

import localeNl from '@angular/common/locales/nl-BE';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import { registerLocaleData } from '@angular/common';

// LOCALE_ID is the bare language ('nl'), so the Belgian Dutch data must be registered under that id.
registerLocaleData(localeNl, 'nl');
registerLocaleData(localeFr);
registerLocaleData(localeEn);

bootstrapApplication(RootComponent, appConfig).catch((err) => console.error(err));
